import { createAction } from "redux-actions";
export const setUserData = createAction("SETUSERDATA");